export const BACKEND_DOMAIN = 'https://qadmin-api.qdemo.co.in'
export const BACKEND_BASE = '/v1'